module.exports = __webpack_public_path__ + "static/media/first-workshop.3ecc4f4a.png";